import React from 'react';
import { Button } from 'components/shadcn/ui/button';

const BackToLogin = ({ resetState }) => {
    return (
        <Button
            className="mx-auto mt-3 block w-max justify-center font-light text-foreground"
            variant="link"
            onClick={resetState}
        >
            <span>back to login</span>
        </Button>
    );
};

export default BackToLogin;
